import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "@iconify/react";
import { Box, Button, Typography, useMediaQuery, useTheme, } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { InfoCard } from "@ui/components/cards/InfoCard";
import { EText } from "@ui/components/event/typography/EText";
import EventAuthFooter from "@ui/components/Footers/EventAuthFooter";
import { SwitchLanguage } from "@ui/components/language";
import { rowCenter, stack1_5 } from "@ui/style/style";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ContentBoxContainer, VideoBackground } from "./AuthWrapper";
import { ContentBox } from "./Login";
import { ContactUs } from "../contact-us";
import { FAQs } from "../faqs";
export const WelcomPage = () => {
    const isSmallScreen = useMediaQuery("(max-width:900px)");
    const { t } = useTranslation();
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only("xs"));
    const isMd = useMediaQuery(theme.breakpoints.down("lg"));
    const isBelow1280 = useMediaQuery(theme.breakpoints.down(1281));
    const [expanded, setExpanded] = useState(false);
    const [isFaqOpen, setIsFaqOpen] = useState(false);
    const [isContactUsOpen, setIsContactUsOpen] = useState(false);
    const handleFAQOpen = () => {
        setIsFaqOpen(true);
        setIsContactUsOpen(false);
    };
    const handleContactUsOpen = () => {
        setIsContactUsOpen(true);
        setIsFaqOpen(false);
    };
    return (_jsxs(Box, { sx: {
            position: "relative",
            height: "100dvh",
            width: "100%",
            overflow: "hidden",
        }, children: [_jsx(Box, { sx: {
                    position: "absolute",
                    top: "120px",
                    left: "0",
                    zIndex: 6,
                    width: "100%",
                    height: "100%",
                    [theme.breakpoints.down(1025)]: {
                        display: "none",
                    },
                }, className: "curve-image", children: _jsx("img", { src: "/assets/images/main-page.png", alt: "Background image", style: { width: "100%", height: "100%" } }) }), _jsx(Box, { sx: {
                    position: "absolute",
                    top: "88px",
                    [theme.breakpoints.up(1025)]: {
                        display: "none",
                    },
                    left: "0",
                    zIndex: 6,
                    width: "100%",
                }, className: "curve-image", children: _jsx("img", { src: "/assets/images/curve-image-mobile.svg", alt: "Background image", style: { width: "100%", height: "100%" } }) }), _jsx(Box, { sx: {
                    position: "absolute",
                    top: "20px",
                    right: "20px",
                    zIndex: 16,
                }, children: _jsx(SwitchLanguage, { buttonProps: {
                        sx: {
                            borderRadius: 2,
                            backgroundColor: "white !important",
                            border: 0,
                            "&:hover": {
                                backgroundColor: "lightgray !important",
                                boxShadow: "none",
                            },
                        },
                        style: {
                            background: "white",
                        },
                    } }) }), _jsx(Box, { sx: {
                    position: "absolute",
                    top: "0",
                    left: "0",
                    zIndex: 5,
                    opacity: 1,
                    width: "100%",
                    height: "100%",
                }, children: _jsx("img", { src: "/assets/images/MainBackground.png", alt: "Background image", style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center center",
                    } }) }), _jsxs("video", { autoPlay: true, loop: true, playsInline: true, className: "background-video", muted: true, style: {
                    position: "absolute",
                    top: 0,
                    zIndex: 5,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    opacity: 0.1,
                }, children: [_jsx("source", { src: "https://euwvdkprdst01.blob.core.windows.net/prod/videos/background-video.mp4" }), "Your browser does not support the video tag."] }), _jsx(VideoBackground, {}), _jsxs(Box, { sx: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    position: "relative",
                    height: "100%",
                    width: "100%",
                    zIndex: 7,
                    overflow: "auto",
                    scrollbarWidth: "none" /* For Firefox */,
                    "&:-webkit-scrollbar-thumb": {
                        display: "none",
                    },
                }, className: "inner-container", children: [_jsx(ContentBoxContainer, { sx: {
                            alignItems: "start",
                            padding: 0,
                            maxWidth: 793,
                            width: "100%",
                            mx: "auto",
                            [theme.breakpoints.between(1024, 1153)]: {
                                py: 0,
                            },
                        }, children: _jsx(Grid, { container: true, spacing: isSmallScreen ? 2 : 5, justifyContent: "space-between", alignItems: "center", height: "100%", children: _jsxs(Grid, { size: { xs: 12, sm: 12, md: 12 }, display: "flex", flexDirection: "column", alignItems: "center", children: [_jsx(Box, { sx: {
                                            ...rowCenter,
                                            backgroundImage: 'url("/assets/images/mock-up-shadow.svg")',
                                            backgroundPosition: "bottom 1.65vh center",
                                            backgroundSize: "13vh",
                                            backgroundRepeat: "no-repeat",
                                        }, children: _jsx(Box, { component: "img", src: "/assets/images/mockup-iphone-front.png", sx: {
                                                maxWidth: 674,
                                                width: "100%",
                                                height: isBelow1280 ? "24dvh" : "26.5dvh",
                                                objectFit: "cover",
                                                display: "block",
                                                [theme.breakpoints.between(1024, 1153)]: {
                                                    height: "22dvh",
                                                },
                                            }, alt: "feature image" }) }), _jsxs(Box, { display: "flex", flexDirection: "column", children: [_jsx(Typography, { fontSize: { xs: 28, md: 32, lg: 40 }, mt: 2, fontFamily: "Formula1", lineHeight: "100%", color: "#FFFFFF", textAlign: "center", textTransform: "uppercase", children: t("eventwelcome.linkSent") }), _jsxs(Box, { display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: 0.5, children: [_jsx(Icon, { icon: "noto:backhand-index-pointing-right", width: 40, height: 40 }), _jsx(Typography, { fontSize: { xs: 28, md: 32, lg: 40 }, fontFamily: "Formula1", lineHeight: "100%", color: "#FFFFFF", textTransform: "uppercase", children: t("eventwelcome.checkEmail") })] })] }), _jsx(ContentBox, { maxWidth: isSmallScreen ? "100%" : "793px", padding: isMd ? "16px 24px 16px 24px" : "40px", sx: {
                                            [theme.breakpoints.down(391)]: {
                                                padding: "20px 24px",
                                            },
                                        }, mt: { xs: 1, lg: 3 }, children: _jsxs(Box, { sx: {
                                                ...stack1_5,
                                                gap: 3,
                                                [theme.breakpoints.down(391)]: { gap: 2 },
                                            }, children: [_jsxs(EText, { sx: {
                                                        fontSize: 18,
                                                        [theme.breakpoints.down(1025)]: {
                                                            fontSize: 16,
                                                        },
                                                        fontWeight: 400,
                                                    }, color: "#000000", textAlign: "left", children: [t("eventwelcome.emailwithLink"), _jsx(Box, { component: "span", sx: {
                                                                fontSize: 18,
                                                                [theme.breakpoints.down(1025)]: {
                                                                    fontSize: 16,
                                                                },
                                                                color: "#00244D",
                                                                fontWeight: 500,
                                                            }, children: t("eventwelcome.openLink") })] }), _jsx(InfoCard, { title: t("event.welcomTitle"), text: t("event.welcomBody") }), _jsx(Button, { onClick: () => setIsContactUsOpen(true), fullWidth: true, variant: "contained", sx: { mt: 1, fontWeight: 500 }, color: "ePrimary", children: t("actions.contactForm") })] }) })] }) }) }), _jsx(EventAuthFooter, { showCredits: true }), isContactUsOpen && (_jsx(ContactUs, { onFAQOpen: handleFAQOpen, open: isContactUsOpen, onClose: () => setIsContactUsOpen(false) })), isFaqOpen && (_jsx(FAQs, { open: isFaqOpen, onContactUsOpen: handleContactUsOpen, onClose: () => setIsFaqOpen(false) }))] })] }));
};
